import { gql, useLazyQuery } from '@apollo/client';
import {AnyObject} from "../../models/types";

export interface GetDiagnosticDumpsVars {
  domainId: string;
  startTime: string;
  endTime?: string;
  hours?: string;
}

interface DiagnosticDumpsResponse {
  getDiagnosticDumps: string[];
}

const GET_DIAGNOSTIC_DUMPS = gql`
    query GetDiagnosticDumps(
      $domainId: String!
      $startTime: String!
      $endTime: String
      $hours: String
    ) {
        getDiagnosticDumps(
          domainId: $domainId
          startTime: $startTime
          endTime: $endTime
          hours: $hours
        )
    }
`;

export const useGetDiagnosticDumps = () => {
  return useLazyQuery<AnyObject, GetDiagnosticDumpsVars>(GET_DIAGNOSTIC_DUMPS, {
    errorPolicy: 'all',
    fetchPolicy: 'no-cache'
  });
};